import {NamaPresenter} from "./NamaPresenter";
import {ajaxJSON} from "../common/NamaCommon";
import FieldSelectorTemplate from "../compiled-templates/FieldSelectorTemplate";
import * as OwnerType from "../constants/OwnerType";
import * as PreferencesRequest from "../constants/PreferencesRequest";
import * as metadata from "../common/Metadata";
import {dropDownFiltering, prepareAllowedValues} from "../widgets/DropDownListWidget";
import {constructDataFromAllowedValues} from "../views/list/ListViewColumns";

export class FieldsSelectorPresenter extends NamaPresenter {
    constructor(place) {
        super(place);
    }

    start() {
        let that = this;
        this.entityName = that.place.entityType;
        this.isFromReportingEntity = (that.place.isFromReportingEntity === "true");
        this.pendingResponseId = that.place.pendingResponseId;
        this.dataSource1 = that.place.dataSource1;
        this.dataSource2 = that.place.dataSource2;
        this.dataSource3 = that.place.dataSource3;
        this.dataSource4 = that.place.dataSource4;
        this.dataSource5 = that.place.dataSource5;
        this.allData = {};
        this.grid = null;
        this.breadcrumb = null;
        this.selectedFieldsGrid = null;
        window.nss = this;
        this.selectedFromERP = [];
        this.allSelectedFieldIds = [];
        this.extraJoins = {};
        window.document.body.innerHTML = FieldSelectorTemplate({});
        window.document.body.style.backgroundImage = "none";
        this.drawWidgets();
    }

    drawWidgets() {
        this.breadcrumb = this.drawBreadCrumb(this.entityName);
        $("body").css("overflow", "hidden");
        this.fetchEntityData(this.entityName, (data) => {
            this.drawGridWithData(data.entityData);
            this.selectedFromERP = data.selectedFromERP;
            this.allSelectedFieldIds = data.allSelectedFieldIds;
            this.extraJoins = data.extraJoins;
            this.drawSelectedFieldsGrid();
            this.drawAllSelectedFieldIdsGrid(data.allSelectedFieldIds);
        });
        $(window).on("resize", () => {
            let height = window.innerHeight;
            let width = window.innerWidth;
            $("#grid").height(height * 2 / 3 - 20);
            this.grid.resize();
            $("#selectedFieldsGrid").height(height / 3 - 30);
            $("#selectedFieldsGrid").width(width * 3 / 5);
            $("#allSelectedFieldIdsGrid").height(height / 3 - 30);
            $("#allSelectedFieldIdsGrid").width(width * 2 / 5);
            this.selectedFieldsGrid.resize();
        });
        let that = this;
        window.onunload = function (e) {
            if (window.okPressed) return null;
            ajaxJSON("wizardFieldsSelection", {
                pendingResponseId: that.pendingResponseId, action: "cancel"
            });
        }
        window.onbeforeunload = function (e) {
            if (window.okPressed) return null;
            return "Are you sure you want to close without save?";
        };
    }

    appendGenRefFieldsIfNeeded() {
        let data = this.extraJoins[this.calcCurrentFullFieldIdFromBreadCrumb()];
        if (data) {
            let gridData = this.grid.dataSource.data();
            for (let i = 0; i < data.length; i++) {
                let current = data.at(i);
                let fieldName = current.slice(0, current.indexOf("#"));
                let createdFrom = gridData.filter(f => f.fullName === fieldName)[0];
                let createdFromIndex = gridData.indexOf(createdFrom);
                let lastIndex = current.length;
                if (current.includes("{"))
                    lastIndex = current.lastIndexOf("{");
                let newItem = {
                    arabicName: createdFrom.arabicName,
                    englishName: createdFrom.englishName,
                    display: "block",
                    fieldType: "Reference",
                    referenceTo: current.slice(current.lastIndexOf("#") + 1, lastIndex),
                    fullName: current,
                    finalId: this.fetchFullParentNameFromBreadCrumbAndAppendDotIfFound() + current,
                };
                gridData.splice(createdFromIndex + 1, 0, newItem);
            }
            this.grid.dataSource.data(gridData);
        }
    }

    checkSelected() {
        let that = this;
        let gridData = that.grid.dataSource.data();
        gridData.forEach(l => l.selected = false);
        for (let i = 0; i < that.selectedFromERP.length; i++) {
            let currentItem = that.selectedFromERP.at(i);
            let filterElement = gridData.filter(f => f.finalId === currentItem.finalId)[0];
            if (filterElement)
                filterElement.set("selected", true);
        }
        that.grid.dataSource.data(gridData);
    }

    onOkClicked() {
        window.okPressed = true;
        window.onbeforeunload = null;
        window.onunload = null;
        ajaxJSON("wizardFieldsSelection", {
            pendingResponseId: this.pendingResponseId,
            mainTable: this.entityName,
            fetchSelectedRows: JSON.stringify(this.selectedFieldsGrid.dataSource.data()),
            action: "done"
        })
        window.close();
    }

    async fetchEntityData(entityName, callback, fullName) {
        let that = this;
        if (fullName && that.allData[fullName]) {
            callback({"entityData": that.allData[fullName]});
            this.checkSelected();
            return;
        }
        await ajaxJSON("wizardFieldsSelection", {
            pendingResponseId: this.pendingResponseId,
            fetchEntityModel: entityName,
            action: "fetchEntityData",
            mainEntityName: that.entityName,
            dataSource1: that.dataSource1,
            dataSource2: that.dataSource2,
            dataSource3: that.dataSource3,
            dataSource4: that.dataSource4,
            dataSource5: that.dataSource5,
        }, (data) => {
            let entityJson = data.entityData;
            let lastItemInBreadCrumb = that.breadcrumb.items()[that.breadcrumb.items().length - 1];
            if (lastItemInBreadCrumb.entityType === entityJson.tableName) {
                lastItemInBreadCrumb.tableType = entityJson.tableType;
                if (entityJson.tableType === 'DetailLine') {
                    lastItemInBreadCrumb.detailParentEntity = entityJson.detailParentEntity;
                    lastItemInBreadCrumb.detailFullName = entityJson.detailFullName;
                }
            }
            let entityDataArray = entityJson.properties;
            entityDataArray = entityDataArray.concat(that.fetchAllDetailsProps(entityJson));
            entityDataArray.forEach(function (element) {
                element.display = that.isReferenceField(element) || element.fieldType === 'Genericreference' ? 'block' : 'none';
                element.finalId = that.fetchFullParentNameFromBreadCrumbAndAppendDotIfFound() + element.fullName;
            });
            data.entityData = entityDataArray;
            callback(data);
            that.appendGenRefFieldsIfNeeded();
            that.checkSelected();
        }, (e) => {
            console.log(e);
        })
    }

    isReferenceField(element) {
        return element.fieldType === 'Reference' || element.referenceTo;
    }

    fetchFullParentNameFromBreadCrumbAndAppendDotIfFound() {
        return this.calcCurrentFullFieldIdFromBreadCrumb() ? this.calcCurrentFullFieldIdFromBreadCrumb() + "." : ""
    }

    fetchAllDetailsProps(entityJson) {
        let detailsProps = [];
        let detailsArray = entityJson.details;
        for (let i = 0; i < detailsArray.length; i++) {
            let currentDetails = detailsArray[i];
            let detailPropertiesArray = currentDetails.properties;
            detailsProps = detailsProps.concat(detailPropertiesArray);
        }
        return detailsProps;
    }

    drawGridWithData(data) {
        let that = this;
        let height = window.innerHeight;
        this.grid = $("#grid").kendoGrid({
            dataSource: {
                data: data, pageSize: 25,
            },
            height: height * 2 / 3 - 20,
            scrollable: true,
            filterable: true,
            sortable: true,
            toolbar: ["search"],
            search: {
                fields: [{name: "fullName", operator: "contains"}, {name: "arabicName", operator: "contains"}, {
                    name: "englishName", operator: "contains"
                }],
            },
            columns: [{field: "fullName", width: 300, title: "Full Name"}, {
                field: "selectedRow", width: "80px", title: "Select", template: (i) => {
                    return `<input type='checkbox' class="k-checkbox select-item" ${i.get("selected") ? "checked" : ""} uid="${i.uid}"/>`
                }
            }, {
                field: "fieldType", width: 160, title: "Reference", nullable: true, template: (i) => {
                    let cellHtml = `<div class="d-flex justify-content-start">`;
                    cellHtml += that.appendReferenceButtonToCellIfNeeded(i);
                    cellHtml += that.appendManualJoinButtonToCellIfNeeded(i);
                    cellHtml += `</div>`;
                    return cellHtml;
                }
            }, {field: "arabicName", title: "Arabic Name"}, {
                field: "englishName",
                title: "English Name"
            }, {field: "fieldType", title: "Field Type"},],
            pageable: {
                position: "bottom", refresh: true, pageSizes: [25, 50, 75, 100, "all"], buttonCount: 5,
            },
        }).getKendoGrid();
        $("#grid").on("click", ".fetch-reference", function (e) {
            that.onFetchClicked($(e.target).closest(".fetch-reference").attr('referenceTo'), $(e.target).closest(".fetch-reference").attr('fullName'));
        });
        $("#grid").on("click", ".fetch-generic-reference", function (e) {
            that.onGenericRefFetchClicked($(e.target).closest(".fetch-generic-reference"), $(e.target).closest(".fetch-generic-reference").attr('finalId'), $(e.target).closest(".fetch-generic-reference").attr('uid'))
        });
        $("#grid").on("click", ".select-item", function (e) {
            that.onSelectedClick(e.target, e.target.attributes['uid'].value);
        });
        if (that.isFromReportingEntity) {
            $(`<div class="form-check">
                  <input class="form-check-input" type="checkbox" id="allowManualJoinForAllFieldTypes">
                  <label class="form-check-label" for="allowManualJoinForAllFieldTypes">Allow Manual Join For All Field Types</label>
                  </div>`).appendTo($(".k-toolbar"));
            $("#allowManualJoinForAllFieldTypes").change(function () {
                that.grid.dataSource.data(that.grid.dataSource.data())
            });
        }
        $("<button class='btn btn-success fw-bold' style='width: 5%'>Save</button>").appendTo($(".k-toolbar")).click(() => {
            this.onOkClicked();
        })
        $("#grid").on("click", ".fetch-manual-join", function (e) {
            that.onManualJoinClicked($(e.target).closest(".fetch-manual-join"));
        });
    }

    appendReferenceButtonToCellIfNeeded(element) {
        if (this.isReferenceField(element) || element.fullName.includes("#")) {
            return `<button title="Go Inside Reference" class="btn btn-success btn-sm fetch-reference" referenceTo='${element.referenceTo}' 
                        fullName='${element.fullName}'><i class="fa-solid fa-arrow-right" style="font-size: 16px"></i></button>`
        } else if (this.isFromReportingEntity && element.fieldType === 'Genericreference') {
            return `<button title="Go Inside Reference" class="btn btn-success btn-sm fetch-reference" referenceTo='EntitySystemEntry'
                        fullName='${element.fullName}#EntitySystemEntry{"joinBy":"targetId"}'><i class="fa-solid fa-arrow-right" style="font-size: 16px"></i></button>
                        <button title="Go Inside Generic Reference" class="btn btn-primary btn-sm fetch-generic-reference"
                        finalId='${element.finalId}' uid='${element.originalUid ? element.originalUid : element.uid}' entityTableType="${element.entityTableType}">
                        <i class="fa-solid fa-arrow-right" style="font-size: 16px"></i></button>`
        } else {
            return ``;
        }
    }

    appendManualJoinButtonToCellIfNeeded(element) {
        if (!this.isFromReportingEntity)
            return "";
        if (element.fullName.includes("#")) {
            return ``;
        } else if ($("#allowManualJoinForAllFieldTypes") && $("#allowManualJoinForAllFieldTypes").prop('checked'))
            return `<button title="Open Manual Join Dialog" class="btn btn-secondary btn-sm fetch-manual-join" referenceTo='${element.referenceTo}' 
                        fullName='${element.fullName}' uid='${element.originalUid ? element.originalUid : element.uid}'>
                        <i class="fa-solid fa-hand-holding"></i></button>`;
        else if (['Genericreference', 'ID'].contains(element.fieldType) || this.isReferenceField(element)) {
            return `<button title="Open Manual Join Dialog" class="btn btn-secondary btn-sm fetch-manual-join" referenceTo='${element.referenceTo}' 
                        fullName='${element.fullName}' uid='${element.originalUid ? element.originalUid : element.uid}'>
                        <i class="fa-solid fa-hand-holding"></i></button>`;
        } else {
            return "";
        }
    }

    calcCurrentFullFieldIdFromBreadCrumb() {
        return this.calcCurrentFullFieldIdFromArray(this.breadcrumb.items());
    }

    calcCurrentFullFieldIdFromArray(items) {
        let fullFieldId = items.filter(l => l.type !== "rootItem")
            .map(l => l.parentPropertyName).join(".");
        return fullFieldId;
    }

    drawBreadCrumb(entityName) {
        let that = this;
        return $("#breadcrumb").kendoBreadcrumb({
            items: [{
                type: "rootItem",
                text: entityName,
                showText: true,
                entityType: entityName,
                parentFullName: "",
                tableType: that.tableType
            }], click: (e) => {
                let index = this.breadcrumb.items().indexOf(e.item);
                for (let i = index + 1; i < this.breadcrumb.items().length; i++) {
                    let fullFieldId = this.calcCurrentFullFieldIdFromArray(this.breadcrumb.items().slice(0, i + 1));
                    let data = this.breadcrumb.items()[i].data;
                    if (i === this.breadcrumb.items().length - 1) data = this.grid.dataSource.data();
                    this.allData[fullFieldId] = data;
                }
                this.breadcrumb.items().splice(index + 1, this.breadcrumb.items().length - index);
                this.grid.dataSource.data(e.item.data);
                this.grid.refresh();
                this.checkSelected();
            }
        }).getKendoBreadcrumb();
    }

    onSelectedClick(e, uid) {
        let currentRow = this.grid.dataSource.getByUid(uid);
        currentRow.set("selected", e.checked);
        let fullParentId = this.calcCurrentFullFieldIdFromBreadCrumb();
        let object = {
            fullParentFieldId: fullParentId,
            fullName: currentRow.fullName,
            arabicName: currentRow.arabicName,
            englishName: currentRow.englishName,
            fieldType: currentRow.fieldType,
            referenceTo: currentRow.referenceTo,
            originalUid: uid,
            finalId: this.fetchFullParentNameFromBreadCrumbAndAppendDotIfFound() + currentRow.fullName,
            parentsPath: this.breadcrumb.items().filter(l => l.type !== "rootItem").map(l => l.parentPropertyName)
        };
        if (e.checked) {
            if (!this.selectedFromERP.some(l => l.finalId === object.finalId))
                this.selectedFromERP.push(object);
            this.selectedFieldsGrid.dataSource.data(this.selectedFromERP);
        } else {
            this.deleteFromSelected(object.fullParentFieldId, object.fullName);
        }
        this.allSelectedFieldsGrid.refresh();
    }

    onFetchClicked(referenceTo, parentPropertyName) {
        $(".k-grid-search>input").val("");
        this.grid.dataSource.filter([]);
        this.breadcrumb.items()[this.breadcrumb.items().length - 1].data = this.grid.dataSource.data();
        this.fetchEntityData(referenceTo, (d) => {
                this.grid.dataSource.data(d.entityData)
            },
            this.fetchFullParentNameFromBreadCrumbAndAppendDotIfFound() + parentPropertyName);
        this.breadcrumb.items().push({
            type: "item",
            text: parentPropertyName + " (" + referenceTo + ")",
            showText: true,
            entityType: referenceTo,
            parentPropertyName: parentPropertyName,
            tableType: this.tableType,
        });
        this.breadcrumb.value(this.breadcrumb.items().map(e => e.text).join("/"));
    }

    async onGoToParentField(finalId) {
        let element = this.selectedFromERP.filter(l => l.finalId === finalId)[0];
        if (!element)
            element = this.allSelectedFieldIds.filter(l => l.finalId === finalId)[0];
        if (!element || !element.parentsPath)
            return;
        this.breadcrumb.items([this.breadcrumb.items()[0]]);
        this.grid.dataSource.data(this.breadcrumb.items()[0].data);
        this.grid.refresh();
        this.checkSelected();
        for (let parent of element.parentsPath) {
            let first = this.grid.dataSource.data().filter(f => f.fullName === parent)[0];
            await this.onFetchClicked(first.referenceTo, first.fullName);
        }
    }

    onManualJoinClicked(target) {
        let that = this;
        let referenceTo = target.attr('referenceTo');
        let fullName = target.attr('fullName');
        let uid = target.attr('uid');
        let dialog = this.buildManualJoinDialog();
        that.manualFieldsDropDown = $("#manual-fields-drop-down").kendoDropDownList({
            filter: "contains",
            enable: false,
            dataValueField: "value",
            dataTextField: "text",
            filtering: function (ev) {
                dropDownFiltering(ev, this.dataSource);
            }
        }).data("kendoDropDownList");
        that.manualEntitiesDropDown = $("#manual-entities-drop-down").kendoDropDownList({
            filter: "contains",
            enable: false,
            dataValueField: "value",
            dataTextField: "text",
            filtering: function (ev) {
                dropDownFiltering(ev, this.dataSource);
            },
            change: function (e) {
                that.manualFieldsDropDown.value("");
                that.manualFieldsDropDown.enable(false);
                if (e.sender.value()) {
                    ajaxJSON("wizardFieldsSelection", {
                        pendingResponseId: that.pendingResponseId,
                        referenceTo: referenceTo,
                        fullName: fullName,
                        entityName: e.sender.value(),
                        mainEntityName: that.entityName,
                        action: "fetchManualJoinFieldsByEntity",
                        allowManualJoinForAllFieldTypes: $("#allowManualJoinForAllFieldTypes").prop('checked')
                    }, (data) => {
                        data.unshift({value: "", text: ""});
                        that.manualFieldsDropDown.dataSource.data(data);
                        that.manualFieldsDropDown.enable(true);
                    });
                }
            }
        }).data("kendoDropDownList");
        that.manualTableTypeDropDown = $("#manual-table-type-drop-down").kendoDropDownList({
            filter: "contains",
            dataValueField: "value",
            dataTextField: "text",
            dataSource: [
                {"value": "", "text": ""},
                {"value": "Entity", "text": "Entity"},
                {"value": "DetailLine", "text": "Detail Line"},
                {"value": "SystemTable", "text": "System Table"}],
            change: function (e) {
                that.manualEntitiesDropDown.value("");
                that.manualEntitiesDropDown.enable(false);
                if (e.sender.value()) {
                    ajaxJSON("wizardFieldsSelection", {
                        pendingResponseId: that.pendingResponseId,
                        tableType: e.sender.value(),
                        action: "fetchEntitiesByTableType"
                    }, (data) => {
                        data.unshift({value: "",text:""});
                        that.manualEntitiesDropDown.dataSource.data(data);
                        that.manualEntitiesDropDown.enable(true);
                    });
                }
            }
        }).data("kendoDropDownList");
        dialog.open();
        dialog.bind("close", function () {
            that.manualTableTypeDropDown.destroy();
            that.manualFieldsDropDown.destroy();
            that.manualEntitiesDropDown.destroy();
            dialog.destroy();
        });

        $("#manual-join-dialog").on("click", ".manual-join-ok-button", function () {
            if (!that.manualTableTypeDropDown.value() || !that.manualEntitiesDropDown.value() || !that.manualFieldsDropDown.value())
                return;
            let gridData = that.grid.dataSource.data();
            let generatedFromItem = that.grid.dataSource.getByUid(uid);
            let selectedField = that.manualFieldsDropDown.dataItem();
            if (gridData.filter(f => f.fullName === selectedField.fullName)[0] || !selectedField) {
                dialog.close();
                return;
            }
            selectedField.display = "block";
            selectedField.finalId = that.fetchFullParentNameFromBreadCrumbAndAppendDotIfFound() + selectedField.fullName;
            gridData.splice(gridData.indexOf(generatedFromItem) + 1, 0, selectedField);
            that.grid.dataSource.data(gridData);
            dialog.close();
            $("#manual-join-dialog").remove();
        });
    }

    buildManualJoinDialog() {
        return $("<div id='manual-join-dialog'></div>").kendoDialog({
            width: "550px",
            title: "Select Manual Join",
            closable: true,
            modal: false,
            content: "<div class='d-flex flex-column align-items-center'>" +
                "<div class='d-flex justify-content-around align-items-center mb-2' style='width:100%'>" +
                "<label for='manual-table-type-drop-down'  style='width:20%;text-align:center;margin: 0'>Table Type</label>" +
                "<input id='manual-table-type-drop-down' style='width:80%'></div>" +
                "<div class='d-flex justify-content-around align-items-center my-2' style='width:100%'>" +
                "<label for='manual-entities-drop-down'  style='width:20%;text-align:center;margin: 0'>Join Entity</label>" +
                "<input id='manual-entities-drop-down' style='width:80%'></div>" +
                "<div class='d-flex justify-content-around align-items-center my-2' style='width:100%'>" +
                "<label for='manual-fields-drop-down' style='width:20%;text-align:center;margin: 0'>Join Field</label>" +
                "<input id='manual-fields-drop-down' style='width:80%'></div>" +
                "<button class='btn btn-success manual-join-ok-button mt-2' style='width:30%;'>Ok</button>" + "</div>",
            close: function () {
                this.destroy();
            }
        }).data("kendoDialog");
    }

    onGenericRefFetchClicked(e, fieldId, uid) {
        let that = this;
        let req = {};
        let lastItemInBreadCrumb = that.breadcrumb.items()[that.breadcrumb.items().length - 1];
        let entityType = lastItemInBreadCrumb.entityType
        let entityTableType = lastItemInBreadCrumb.tableType;
        if (e.attr('entityTableType') !== "undefined") {
            entityTableType = e.attr('entityTableType');
            entityType = fieldId.slice(fieldId.lastIndexOf("#") + 1, fieldId.lastIndexOf("{"));
            fieldId = fieldId.slice(fieldId.lastIndexOf(":\"") + 2, fieldId.lastIndexOf("\"}"));
        }
        if (entityTableType === "DetailLine") {
            entityType = lastItemInBreadCrumb.detailParentEntity;
            fieldId = lastItemInBreadCrumb.detailFullName + "." + fieldId;
        } else if (entityTableType && entityTableType === "SystemTable") {
            entityType = "MeetingRemark";
            fieldId = "ref20";
        }
        req.owner = {ownerType: OwnerType.Entity, ownerId: entityType};
        req.properties = [PreferencesRequest.META_DATA];
        metadata.fetchPreferences(req, (preferences) => {
            let entityMetadata = preferences[PreferencesRequest.META_DATA];
            let dialog = that.drawDialogForGenericRef(entityMetadata, fieldId);
            dialog.open();

            $("#dialog").on("click", ".entity-select-btn", function () {
                let gridData = that.grid.dataSource.data();
                let generatedFromItem = that.grid.dataSource.getByUid(uid);
                let selectedEntity = that.dropDown.value();
                if (gridData.filter(f => f.fullName === generatedFromItem.fullName + "#" + selectedEntity)[0] || !selectedEntity) {
                    dialog.close();
                    dialog.destroy();
                    return;
                }
                let newItem = {
                    arabicName: generatedFromItem.arabicName,
                    englishName: generatedFromItem.englishName,
                    display: "block",
                    fieldType: "Reference",
                    referenceTo: selectedEntity,
                    fullName: generatedFromItem.fullName + "#" + selectedEntity,
                    finalId: generatedFromItem.finalId
                };
                gridData.splice(gridData.indexOf(generatedFromItem) + 1, 0, newItem);
                that.grid.dataSource.data(gridData);
                dialog.close();
                $("#dialog").remove();
            });
        })
    };

    drawDialogForGenericRef(entityMetadata, fieldId) {
        let that = this;
        let dialog = $("<div id='dialog'></div>").kendoDialog({
            width: "450px",
            title: "Select Entity Type",
            closable: true,
            modal: false,
            content: "<div class='d-flex flex-column align-items-center'><input id='generic-compo' class='my-2'>" + "<button class='btn btn-success entity-select-btn'>Ok</button></div>",
            close: function () {
                that.dropDown.destroy();
                dialog.destroy();
            }
        }).data("kendoDialog");

        let allowedEntityTypes = [{text: "", value: "", originText: ""}];
        fieldId = fieldId.substring(that.calcCurrentFullFieldIdFromBreadCrumb().length ? that.calcCurrentFullFieldIdFromBreadCrumb().length + 1 : 0)
        let allowedValues = prepareAllowedValues(metadata.findFieldMetadata(fieldId, entityMetadata));
        if (allowedValues) allowedEntityTypes = constructDataFromAllowedValues(allowedValues);
        that.dropDown = $("#generic-compo").kendoDropDownList({
            filter: "contains",
            dataValueField: "value",
            dataTextField: "text",
            dataSource: allowedEntityTypes,
            filtering: function (ev) {
                dropDownFiltering(ev, this.dataSource);
            }
        }).data("kendoDropDownList");

        return dialog;
    }

    drawSelectedFieldsGrid() {
        let that = this;
        let height = window.innerHeight;
        let width = window.innerWidth;
        this.selectedFieldsGrid = $("#selectedFieldsGrid").kendoGrid({
            dataSource: {
                data: that.selectedFromERP,
                pageSize: 10
            },
            pageable: true,
            height: height / 3 - 30,
            width: width * 3 / 5,
            resizable: true,
            columns: [
                {draggable: true, width: "40px"},
                {field: "finalId", title: "Full Id"},
                {field: "arabicName", title: "Arabic Name"},
                {field: "englishName", title: "English Name"},
                {
                    field: "Delete", width: 300, title: "Actions", template: (i) => {
                        let cellHtml = `<button title="Go To Parent" class="btn btn-warning btn-sm d-block goToParentBtn" final-id='${i.finalId}'>
                        <i class="fa-solid fa-arrow-right" style="font-size: 16px"></i></button>`;
                        cellHtml += that.appendReferenceButtonToCellIfNeeded(i);
                        return `<div class="w-100 h-100 d-flex justify-content-start align-items-center">${cellHtml}
                            <button title="Delete" class="btn btn-danger btn-sm d-block deleteSelected" fullName='${i.fullName}'
                            fullParentFieldId='${i.fullParentFieldId}'>
                            <i class="fa-solid fa-trash" style="font-size: 16px"></i>
                            </button>
                            <button title="Move To First" class="btn btn-danger btn-sm d-block moveToFirst" final-id='${i.finalId}'>
                            <i class="fa fa-angle-double-up" style="font-size: 16px"></i>
                            </button>
                            <button title="Move Top" class="btn btn-danger btn-sm d-block moveToTop" final-id='${i.finalId}'>
                            <i class="fa fa-arrow-up" style="font-size: 16px"></i>
                            </button>
                            <button title="Move Down" class="btn btn-danger btn-sm d-block moveToDown" final-id='${i.finalId}'>
                            <i class="fa fa-arrow-down" style="font-size: 16px"></i>
                            </button>
                            <button title="Move To Last" class="btn btn-danger btn-sm d-block moveToLast" final-id='${i.finalId}'>
                            <i class="fa fa-angle-double-down" style="font-size: 16px"></i>
                            </button>
                            </div>`;
                    }
                },],
            editable: "inline",
            reorderable: {
                rows: true
            },
        }).getKendoGrid();
        $("#selectedFieldsGrid").on("click", ".deleteSelected", function (e) {
            that.deleteFromSelected($(e.target).closest(".deleteSelected").attr('fullParentFieldId'), $(e.target).closest(".deleteSelected").attr('fullName'));
        });
        $("#selectedFieldsGrid").on("click", ".goToParentBtn", function (e) {
            that.onGoToParentField($(e.target).closest(".goToParentBtn").attr('final-id'));
        });
        $("#selectedFieldsGrid").on("click", ".moveToFirst", function (e) {
            that.moveItem($(e.target).closest(".moveToFirst").attr('final-id'), "FIRST")
        });
        $("#selectedFieldsGrid").on("click", ".moveToTop", function (e) {
            that.moveItem($(e.target).closest(".moveToTop").attr('final-id'), "TOP")
        });
        $("#selectedFieldsGrid").on("click", ".moveToDown", function (e) {
            that.moveItem($(e.target).closest(".moveToDown").attr('final-id'), "DOWN")
        });
        $("#selectedFieldsGrid").on("click", ".moveToLast", function (e) {
            that.moveItem($(e.target).closest(".moveToLast").attr('final-id'), "LAST")
        });
        $("#selectedFieldsGrid").on("click", ".fetch-reference", function (e) {
            that.onFetchClicked($(e.target).closest(".fetch-reference").attr('referenceTo'), $(e.target).closest(".fetch-reference").attr('fullName'));
        });
        $("#selectedFieldsGrid").on("click", ".fetch-generic-reference", function (e) {
            that.onGenericRefFetchClicked($(e.target).closest(".fetch-generic-reference"), $(e.target).closest(".fetch-generic-reference").attr('finalId'), $(e.target).closest(".fetch-generic-reference").attr('uid'))
        });
    }

    drawAllSelectedFieldIdsGrid(data) {
        let that = this;
        let height = window.innerHeight;
        let width = window.innerWidth;
        this.allSelectedFieldsGrid = $("#allSelectedFieldIdsGrid").kendoGrid({
            dataSource: {
                data: data, pageSize: 10
            },
            height: height / 3 - 30,
            width: width * 2 / 5,
            columns: [
                {field: "finalId", title: "Full Id"},
                {
                    title: "Actions", width: 220, template: (i) => {
                        let selectBtn = that.selectedFieldsGrid.dataSource.data().some(l => l.finalId === i.finalId) ? ""
                            : `<button title='Select' class='btn btn-primary success btn-sm select' objectId='${i.uid}'>Select</button>`;
                        let cellHtml = `<button title="Go To Parent" class="btn btn-warning btn-sm d-block goToParentBtn" final-id='${i.finalId}'>
                        <i class="fa-solid fa-arrow-right" style="font-size: 16px"></i></button>`;
                        cellHtml += that.appendReferenceButtonToCellIfNeeded(i);
                        return `<div class="w-100 h-100 d-flex justify-content-start align-items-center">${selectBtn}${cellHtml}</div>`;
                    }
                },
            ],
        }).getKendoGrid();
        $("#allSelectedFieldIdsGrid").on("click", ".goToParentBtn", function (e) {
            that.onGoToParentField($(e.target).closest(".goToParentBtn").attr('final-id'));
        });
        $("#allSelectedFieldIdsGrid").on("click", ".fetch-reference", function (e) {
            that.onFetchClicked($(e.target).closest(".fetch-reference").attr('referenceTo'), $(e.target).closest(".fetch-reference").attr('fullName'));
        });
        $("#allSelectedFieldIdsGrid").on("click", ".fetch-generic-reference", function (e) {
            that.onGenericRefFetchClicked($(e.target).closest(".fetch-generic-reference"), $(e.target).closest(".fetch-generic-reference").attr('finalId'), $(e.target).closest(".fetch-generic-reference").attr('uid'))
        });
        $("#allSelectedFieldIdsGrid").on("click", ".select", function (e) {
            that.onSelectFromAllSelectedGridClicked(e.target.attributes['objectId'].value);
        });
    }

    moveItem(finalId, direction) {
        let gridData = this.selectedFieldsGrid.dataSource.data();
        if (gridData.length === 1)
            return;
        let element = gridData.filter(l => l.finalId === finalId)[0];
        let currentIndex = gridData.indexOf(element);
        switch (direction) {
            case "FIRST":
                gridData = [element, ...gridData.filter(l => l !== element)];
                break;
            case "TOP":
                if (currentIndex === 0)
                    break;
                gridData[currentIndex] = gridData[currentIndex - 1];
                gridData[currentIndex - 1] = element;
                break;
            case "DOWN":
                if (currentIndex === gridData.length - 1)
                    break;
                gridData[currentIndex] = gridData[currentIndex + 1];
                gridData[currentIndex + 1] = element;
                break;
            case "LAST":
                gridData = [...gridData.filter(l => l !== element), element];
                break;
        }
        this.selectedFieldsGrid.dataSource.data(gridData);
    }

    deleteFromSelected(fullParentFieldId, fullName) {
        let finalId = (fullParentFieldId ? fullParentFieldId + "." : "") + fullName;
        for (let i = this.selectedFromERP.length - 1; i >= 0; i--) {
            let l = this.selectedFromERP[i];
            if (l.finalId === finalId) {
                this.selectedFromERP = this.selectedFromERP.filter(l => l.finalId !== finalId);
                if (this.calcCurrentFullFieldIdFromBreadCrumb() === fullParentFieldId) {
                    this.checkSelected();
                }
                break;
            }
        }
        this.selectedFieldsGrid.dataSource.data(this.selectedFromERP);
        this.allSelectedFieldsGrid.refresh();
    }

    onSelectFromAllSelectedGridClicked(obj) {
        let currentRow = this.allSelectedFieldsGrid.dataSource.getByUid(obj);
        if (!this.selectedFromERP.some(l => l.finalId === currentRow.finalId)) {
            this.selectedFromERP.push(currentRow);
            this.selectedFieldsGrid.dataSource.data(this.selectedFromERP);
            this.checkSelected();
        }
        this.allSelectedFieldsGrid.refresh();
    }
}